module.exports = __webpack_public_path__ + "img/kube.48c2bc54.png";